/**
 * The same-origin base path the VN dashboard is served under. The vn-pwa handoff navigates here and
 * its service worker forces this tree network-only; this is the dashboard-side copy of that cross-app
 * contract (the two repos share no runtime package, so each keeps its own literal — keep them in
 * sync). Used as the router basename so every in-app route resolves under `/app`.
 */
export const APP_BASE_PATH = '/app'
